module.exports = __webpack_public_path__ + "static/media/view doctor.39c2bfb6.svg";